import { PaginationMeta } from "lago-javascript-client";
import { z } from "zod";

export const PaginationSchema = z.object({
  nextPage: z.number().nullable(),
  prevPage: z.number().nullable(),
  currentPage: z.number(),
  totalPages: z.number(),
  count: z.number()
});

export type Pagination = z.infer<typeof PaginationSchema>;

// TODO:
// The following Paginated type can also
// be done like this:
//    export type Paginated<T> = [T, Pagination];
// To avoid having a service aware of the data field
export type Paginated<T> = {
  data: T;
  metadata: Pagination;
};

// Type guard
export function isPaginated<T>(value: Paginated<T> | T): value is Paginated<T> {
  return (value as Paginated<T>)?.metadata !== undefined;
}

export function mapPagination(lagoMetadata: PaginationMeta) {
  return {
    nextPage: lagoMetadata.next_page,
    prevPage: lagoMetadata.prev_page,
    currentPage: lagoMetadata.current_page,
    totalPages: lagoMetadata.total_pages,
    count: lagoMetadata.total_count
  };
}
